<template lang="pug">
  .history__container
    .mode-select
      el-select(v-model="mode" @change="loadHistory")
        el-option(v-for="current in modes" :value="current.value" :label="current.locale" :key="`select-mode-${current.value}`")
    .table__container
      .table-list__container
        el-table(
          v-loading="isLoading"
          :data="history.list"
          style="width: 100%; font-size: 12px",
        )
          el-table-column(prop="created" label="Время" width="200")
          el-table-column(prop="amount" label="Сумма" width="150")
          el-table-column(prop="comment" label="Комментарий" width="150")
          el-table-column(v-if="mode === 'payouts'" prop="wallet" label="Кошелек" width="300")
      .table-pagination__container
        el-pagination(
          style="margin-top: 20px"
          v-if='hasPagination',
          :total='history.pagination.total',
          :page-size="per_page",
          :current-page='history.pagination.page',
          background,
          layout='prev, pager, next',
          @current-change='loadHistory',
        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_ACCOUNT_PAYINS, LOAD_ACCOUNT_PAYOUTS } from "../../store/const/accounts";

export default {
  name: 'AccountHistory',
  props: {
    account: { type: String, default: () => '' }
  },
  data() {
    return {
      page: 1,
      per_page: 25,
      mode: 'payouts',
      modes: [
        { value: 'payouts', locale: 'Список выводов' },
        { value: 'payins', locale: 'Список пополнений' },
      ],
      history: {
        list: [],
        pagination: {},
      },
    }
  },
  async mounted() {
    await this.loadHistory();
  },
  computed: {
    ...mapGetters([
      'loading',
    ]),
    isLoading() {
      return this.loading(LOAD_ACCOUNT_PAYOUTS) === 'loading' || this.loading(LOAD_ACCOUNT_PAYINS) === 'loading';
    },
    hasPagination() {
      return this.history.pagination.count > this.per_page;
    },
  },
  methods: {
    ...mapActions('accounts', {
      loadAccountPayouts: LOAD_ACCOUNT_PAYOUTS,
      loadAccountPayins: LOAD_ACCOUNT_PAYINS,
    }),
    async loadHistory(page = 1) {
      const method = this.mode === 'payouts' ? this.loadAccountPayouts : this.loadAccountPayins;
      const params = { page, per_page: this.per_page };
      const request = await method({ name: this.account, params });
      if (request.success) {
        this.history.list = request.data.list;
        this.history.pagination = request.data.pagination;
        this.page = page;
      } else {
        this.$message.error(`Неудачный запрос: ${request.message || 'Неизвестная ошибка'}`);
      }
    }
  }
};
</script>
<style>
</style>
